// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Forcer le z-index des menus Material-UI au-dessus des modals */
.MuiPopover-root,
.MuiMenu-root,
.MuiModal-root:has(.MuiMenu-root),
.MuiModal-root:has(.MuiPopover-root) {
  z-index: 1600 !important;
}

/* Spécifiquement pour les Select et Autocomplete */
.MuiSelect-popper,
.MuiAutocomplete-popper {
  z-index: 1600 !important;
}

/* Assurer que les dropdowns restent au-dessus */
.MuiFormControl-root .MuiPopover-root,
.MuiFormControl-root .MuiMenu-root {
  z-index: 1600 !important;
}



`, "",{"version":3,"sources":["webpack://./src/components/calendar/ConflictCheckDialog.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;;;;EAIE,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;;EAEE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;;EAEE,wBAAwB;AAC1B","sourcesContent":["/* Forcer le z-index des menus Material-UI au-dessus des modals */\n.MuiPopover-root,\n.MuiMenu-root,\n.MuiModal-root:has(.MuiMenu-root),\n.MuiModal-root:has(.MuiPopover-root) {\n  z-index: 1600 !important;\n}\n\n/* Spécifiquement pour les Select et Autocomplete */\n.MuiSelect-popper,\n.MuiAutocomplete-popper {\n  z-index: 1600 !important;\n}\n\n/* Assurer que les dropdowns restent au-dessus */\n.MuiFormControl-root .MuiPopover-root,\n.MuiFormControl-root .MuiMenu-root {\n  z-index: 1600 !important;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
